/* Этот файл сгенерирован автоматически на основe шаблона exportService.hbs */
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateCallLinkResponse } from '../models';
import type { CreateInviteLinkRequest } from '../models';
import type { JoinCallByLinkResponse } from '../models';
import type { JoinCallByLinkResponseV2 } from '../models';
import type { JoinCallResponse } from '../models';
import type { JoinCallResponseV2 } from '../models';
import type { StartCallResponse } from '../models';
import type { StartCallResponseV2 } from '../models';
import type { VcsAuthorizedJoinCallByLinkRequest } from '../models';
import type { VcsCallModeratorRequest } from '../models';
import type { VcsCancelWaitingForJoinRequest } from '../models';
import type { VcsChangeJoinApprovalPolicyForInviteLinkRequest } from '../models';
import type { VcsChangeJoinApprovalPolicyRequest } from '../models';
import type { VcsChangeOnlyModeratorsCanApproveWaitingUsersRequest } from '../models';
import type { VcsChangeWebinarModeRequest } from '../models';
import type { VcsIncomingCallRequest } from '../models';
import type { VcsJoinCallByLinkRequest } from '../models';
import type { VcsJoinCallRequest } from '../models';
import type { VcsOutlookPluginCreateInviteLinkRequest } from '../models';
import type { VcsStartCallRequest } from '../models';
import type { VcsWaitingRoomRequest } from '../models';
import { request } from 'api/apiRouter';
import type { ApiRequestOptions, ApiResponse } from '@web-chat-core/toolkit/src/api3';
export class VcsMessagingControllerService {
    public static timeOutCall(
        workspaceId: number,
        requestBody: VcsIncomingCallRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<boolean>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/timeOutCall',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static startCall(
        workspaceId: number,
        requestBody: VcsStartCallRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<StartCallResponse>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/startCall',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static startCallV2(
        workspaceId: number,
        requestBody: VcsStartCallRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<StartCallResponseV2>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/startCallV2',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static removeSpeakerFromCall(
        workspaceId: number,
        requestBody: VcsCallModeratorRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<boolean>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/removeSpeakerFromCall',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static removeSpeakerFromCallOAuth(
        requestBody: VcsCallModeratorRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<boolean>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/removeSpeakerFromCallOAuth',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static removeModeratorFromCall(
        workspaceId: number,
        requestBody: VcsCallModeratorRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<boolean>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/removeModeratorFromCall',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static removeModeratorFromCallOAuth(
        requestBody: VcsCallModeratorRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<boolean>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/removeModeratorFromCallOAuth',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static rejectIncomingCall(
        workspaceId: number,
        requestBody: VcsIncomingCallRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<boolean>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/rejectIncomingCall',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static joinCall(
        workspaceId: number,
        requestBody: VcsJoinCallRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<JoinCallResponse>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/joinCall',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static joinCallV2(
        workspaceId: number,
        requestBody: VcsJoinCallRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<JoinCallResponseV2>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/joinCallV2',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static joinCallByLink(
        requestBody: VcsJoinCallByLinkRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<JoinCallByLinkResponse>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/joinCallByLink',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static joinCallByLinkV2(
        requestBody: VcsJoinCallByLinkRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<JoinCallByLinkResponseV2>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/joinCallByLinkV2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static joinCallByLinkOAuth(
        requestBody: VcsJoinCallByLinkRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<JoinCallByLinkResponse>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/joinCallByLinkOAuth',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static joinCallByLinkOAuthV2(
        requestBody: VcsJoinCallByLinkRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<JoinCallByLinkResponseV2>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/joinCallByLinkOAuthV2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static joinCallByLinkAuthorized(
        workspaceId: number,
        requestBody: VcsAuthorizedJoinCallByLinkRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<JoinCallByLinkResponse>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/joinCallByLinkAuthorized',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static joinCallByLinkAuthorizedV2(
        workspaceId: number,
        requestBody: VcsAuthorizedJoinCallByLinkRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<JoinCallByLinkResponseV2>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/joinCallByLinkAuthorizedV2',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static createInviteLink(
        workspaceId: number,
        requestBody?: any,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<CreateCallLinkResponse>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/createInviteLink',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static createInviteLinkV2(
        workspaceId: number,
        requestBody?: CreateInviteLinkRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<CreateCallLinkResponse>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/createInviteLinkV2',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static createInviteLinkOutlookPlugin(
        requestBody: VcsOutlookPluginCreateInviteLinkRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<CreateCallLinkResponse>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/createInviteLinkOutlookPlugin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static changeWebinarMode(
        workspaceId: number,
        requestBody: VcsChangeWebinarModeRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<boolean>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/changeWebinarMode',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static changeWebinarModeOAuth(
        requestBody: VcsChangeWebinarModeRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<boolean>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/changeWebinarModeOAuth',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static changeOnlyModeratorsCanApproveWaitingUsers(
        workspaceId: number,
        requestBody: VcsChangeOnlyModeratorsCanApproveWaitingUsersRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<boolean>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/changeOnlyModeratorsCanApproveWaitingUsers',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static changeOnlyModeratorsCanApproveWaitingUsersOAuth(
        requestBody: VcsChangeOnlyModeratorsCanApproveWaitingUsersRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<boolean>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/changeOnlyModeratorsCanApproveWaitingUsersOAuth',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static changeJoinApprovalPolicy(
        workspaceId: number,
        requestBody: VcsChangeJoinApprovalPolicyRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<boolean>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/changeJoinApprovalPolicy',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static changeJoinApprovalPolicyOAuth(
        requestBody: VcsChangeJoinApprovalPolicyRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<boolean>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/changeJoinApprovalPolicyOAuth',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static changeJoinApprovalPolicyForInviteLink(
        workspaceId: number,
        requestBody: VcsChangeJoinApprovalPolicyForInviteLinkRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<boolean>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/changeJoinApprovalPolicyForInviteLink',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static cancelWaitingForJoin(
        workspaceId: number,
        requestBody: VcsCancelWaitingForJoinRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<boolean>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/cancelWaitingForJoin',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static cancelWaitingForJoinOAuth(
        requestBody: VcsCancelWaitingForJoinRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<boolean>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/cancelWaitingForJoinOAuth',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static cancelCall(
        workspaceId: number,
        requestBody: VcsIncomingCallRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<boolean>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/cancelCall',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static assignSpeakerToCall(
        workspaceId: number,
        requestBody: VcsCallModeratorRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<boolean>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/assignSpeakerToCall',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static assignSpeakerToCallOAuth(
        requestBody: VcsCallModeratorRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<boolean>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/assignSpeakerToCallOAuth',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static assignModeratorToCall(
        workspaceId: number,
        requestBody: VcsCallModeratorRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<boolean>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/assignModeratorToCall',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static assignModeratorToCallOAuth(
        requestBody: VcsCallModeratorRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<boolean>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/assignModeratorToCallOAuth',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static approveWaitingUser(
        workspaceId: number,
        requestBody: VcsWaitingRoomRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<boolean>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/approveWaitingUser',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static approveWaitingUserOAuth(
        requestBody: VcsWaitingRoomRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<boolean>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/vcs/approveWaitingUserOAuth',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
}
